import React, { useEffect, useState } from "react";
import { API_BASE } from './apiBase';

// North America access gate. PointClickCare requires 2-legged integrations to
// keep user access within North America, so before the app renders its data we
// ask the API (which does the authoritative IP → country check) whether this
// client is permitted. Blocked → a full-screen notice instead of the app.
// While the check is in flight we render the app optimistically (the API also
// enforces the block on every data route, so nothing sensitive loads if the
// region isn't allowed); on a network error we fail open so a probe failure
// never locks out a legitimate user.
const API = API_BASE;   // src/apiBase.js is the only place the host is written

export default function GeoGate({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ok | blocked

  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/geo-check`)
      .then((r) => r.json())
      .then((d) => { if (alive) setStatus(d && d.allowed === false ? "blocked" : "ok"); })
      .catch(() => { if (alive) setStatus("ok"); });
    return () => { alive = false; };
  }, []);

  if (status === "blocked") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f7f5f1", fontFamily: "'Instrument Sans', system-ui, sans-serif" }}>
        <div style={{ maxWidth: 460, textAlign: "center", background: "var(--ed-canvas)", border: "1px solid #e7e4dd", borderRadius: 14, padding: "36px 32px" }}>
          <div style={{ fontSize: 30, marginBottom: 12 }}>🌎</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: "#0f1a24", margin: "0 0 10px" }}>Not available in your region</h1>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: "#3b4a5a", margin: 0 }}>
            SurvAIHealth is available only within North America. Access from your current region is not permitted. If you believe this is an error, contact <a href="mailto:aware@survaihealth.com" style={{ color: "#0b5566" }}>aware@survaihealth.com</a>.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
